import Vue from 'vue';
import Router from 'vue-router';
/*
import Portfolio from './views/Portfolio.vue';
*/


Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: '/studio',
    },
    {
        path: '/studio',
        component: () => import('./views/ReyrockLanding.vue'),
    },
    {
        path: '/properties',
        name: 'Properties',
        component: () => import('./views/Properties.vue'),
        meta: { title: 'Properties', key: 'properties' }
    },
    {
        path: '/ventures',
        name: 'Ventures',
        component: () => import('./views/Ventures.vue'),
        meta: { title: 'Ventures', key: 'ventures' }
    },
    {
        path: '/talent',
        name: 'Talent',
        component: () => import('./views/Talent.vue'),
        meta: { title: 'Talent', key: 'talent' }
    },
    {
        path: '/capital',
        name: 'Capital',
        component: () => import('./views/Capital.vue'),
        meta: {
            title: 'Capital',
            key: 'capital'
        }
    },
    {
        path: '/operations',
        name: 'Operations',
        component: () => import('./views/Operations.vue'),
        meta: {
            title: 'Operations',
            key: 'operations'
        }
    },
    {
        path: '/pages/:slug?',
        name: 'Page',
        component: () => import('./views/ArticleRelocator.vue'),
    },
    {
        path: '*',
        component: () => import('./views/NotFound.vue'),
    }
];

export default new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH || '/', 
    routes,
});